<template>
  <el-dialog
      :visible.sync="show"
      width="400px"
      :close-on-click-modal="false"
      destroy-on-close
      @close="close"
  >
    <div class="qrcode">
      <qrcode :value="qrcode"/>
      <div class="tip">微信扫一扫，授权登录</div>
    </div>
  </el-dialog>
</template>
<script>
import Qrcode from "@/components/Qrcode";
import {getBrowserCode} from "@/utils/browser-code";
import messageBus from '@/utils/socket/bus.js'
import {setQrcodeToken} from "@/utils/qrcode-token";

export default {
  name: "WechatQrcodeLayer",
  components: {Qrcode},
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      show: false,
      qrcode: ''
    }
  },
  created() {
    const that = this
    messageBus.$on('onMessage', data => {
      if (data['type'] === 'apiQrcodeMpLogin') {
        setQrcodeToken(data.apiQrcodeMpOpenId)
        location.reload()
      }
    })
  },
  watch: {
    visible: {
      handler(val) {
        if (val) {
          this.show = val
          this.$request.get('/Qrcode/wechatAuthUrl', {
            params: {
              source: getBrowserCode()
            }
          }).then(res => {
            if (res.code === 0) {
              this.qrcode = res.data
            }
          })
        }
      }
    }
  },
  methods: {
    /**
     * 关闭
     */
    close() {
      this.qrcode = ''
      this.$emit('update:visible', false)
    }
  }
}
</script>


<style scoped lang="scss">
.qrcode {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 334px;

  .tip {
    font-size: 14px;
    margin-top: 10px;
    color: #2D2D2D;
  }
}
</style>